import { AbstractRouterFilter } from '@zk/framework-vue';
import { getToken } from 'common-module/src/util/auth';
import { isOverseasVersion } from 'common-module/src/util';
const PATH = '/project/create';
const OVERSEAS_GUIDE_PATH = '/welcome';
export default class ProjectCreateFilter extends AbstractRouterFilter {
  isLoad = false;
  isLoadOverseasGuideStep = false;
  order() {
    return super.order() + 7;
  }
  matches(to, from) {
    return super.matches(to, from) && getToken() && to.meta.share !== true;
  }

  async onBefore(to) {
    const { option: { store } } = this;

    // 海外版新手引导相关
    if (isOverseasVersion){
      if (!this.isLoadOverseasGuideStep){
        await store.dispatch('overseasGuide/getFirstGuideStep');
      }
      const isFinishFirstGuide = store.getters['overseasGuide/isFinishFirstGuide'];
      if (!isFinishFirstGuide) {
        if (to.path !== OVERSEAS_GUIDE_PATH) {
          return OVERSEAS_GUIDE_PATH;
        }
        return true;
      }
    }
    
    if (to.path === OVERSEAS_GUIDE_PATH) {
      return '/';
    }

    if (!this.isLoad) {
      await store.dispatch('app/loadProjects');
    }
    const { state: { app: { projectList } } } = store;
    if (!projectList || projectList.length <= 0) {
      if (to.path !== PATH) {
        return PATH;
      }
      return true;
    }
    if (to.path === PATH) {
      return '/';
    }
  }

  onAfter() {
    this.isLoad = true;
    this.isLoadOverseasGuideStep = true;
  }
}
